import type { ContentSession } from '@/src/queries/library-queries'

export type LibrarySection = {
  title: string
  data: ContentSession[]
  isFeatured: boolean
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value != null
}

export function getErrorStatus(error: unknown): number | null {
  if (!isRecord(error)) {
    return null
  }

  return typeof error.status === 'number' ? error.status : null
}

export function getSessionSubtitle(session: ContentSession) {
  if (session.description?.length) return session.description
  if (session.category?.title?.length) return session.category.title
  return undefined
}

export function buildLibrarySections({
  sessions,
  favoriteContentIds,
  featuredTitle,
  libraryTitle,
}: {
  sessions: ContentSession[]
  favoriteContentIds: Set<string>
  featuredTitle: string
  libraryTitle: string
}): LibrarySection[] {
  if (!sessions?.length) {
    return []
  }

  const starredItems = sessions.filter((session) =>
    favoriteContentIds.has(session.id),
  )
  const unstarredItems = sessions.filter(
    (session) => !favoriteContentIds.has(session.id),
  )

  return [
    {
      title: featuredTitle,
      data: starredItems,
      isFeatured: true,
    },
    {
      title: libraryTitle,
      data: unstarredItems,
      isFeatured: false,
    },
  ]
}
